
// PATHS
import axios from "axios";

const SEARCH_APPLICATION = 'network/application/find';

const searchApplication: any = async (req: any) => {
    const response = await axios.post(SEARCH_APPLICATION, req);
    return response.data;
}

export {
    searchApplication
}